// Mutation hook - wymiana OAuth code z popup Meta Embedded Signup na permanent token.
// POST /api/ui/sales-crm/whatsapp/embedded-signup/exchange-code
// Faza 7 - 3-step (code -> token -> subscribe webhook -> persist).

import { axios } from 'api';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import { getWhatsappEmbeddedSignupConfigQueryKey } from 'api/endpoints/useGetWhatsappEmbeddedSignupConfig';

export interface IPostExchangeWhatsappSignupCodeRequest {
  code: string;
  phoneNumberId: string;
  wabaId: string;
}

export interface IPostExchangeWhatsappSignupCodeResponse {
  data?: {
    success?: boolean;
    displayPhoneNumber?: string;
  };
  message?: string;
  status?: string;
}

const postExchangeWhatsappSignupCode = (
  body: IPostExchangeWhatsappSignupCodeRequest
): Promise<IPostExchangeWhatsappSignupCodeResponse> =>
  axios.post('/sales-crm/whatsapp/embedded-signup/exchange-code', body);

export const usePostExchangeWhatsappSignupCode = (
  options?: UseMutationOptions<
    IPostExchangeWhatsappSignupCodeResponse,
    IError,
    IPostExchangeWhatsappSignupCodeRequest
  >
) => {
  const queryClient = useQueryClient();
  return useMutation<
    IPostExchangeWhatsappSignupCodeResponse,
    IError,
    IPostExchangeWhatsappSignupCodeRequest
  >(postExchangeWhatsappSignupCode, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(getWhatsappEmbeddedSignupConfigQueryKey);
      options?.onSuccess?.(data, variables, context);
    }
  });
};
